import { apiClient } from './client';

export function getTenantLaunchReadiness(tenantId) {
  return apiClient.get(`/api/system/tenants/${tenantId}/launch-readiness`).then((r) => r.data.data);
}

export function generateTenantLaunchReadiness(tenantId, payload = {}) {
  return apiClient.post(`/api/system/tenants/${tenantId}/launch-readiness/generate`, payload).then((r) => r.data.data);
}

export function getLatestTenantLaunchReadiness(tenantId) {
  return apiClient.get(`/api/system/tenants/${tenantId}/launch-readiness/latest`).then((r) => r.data.data);
}

export function getCustomerPortalLaunchReadinessSummary(customerId, tenantId) {
  return apiClient
    .get(`/api/customer-portal/customers/${customerId}/tenants/${tenantId}/launch-readiness-summary`)
    .then((r) => r.data.data);
}
